import {Flex} from "@chakra-ui/react";
import React from "react";

import PayoutTabs from "../tabs/PayoutTabs";

const PayoutsGroup = () => {
  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="flex-start"
      gap={5}
      pt={{ base: "130px", md: "80px", xl: "80px" }}
    >
      {/* <Settlement type="amount"/> */}
      <PayoutTabs />
    </Flex>
  );
};

export default PayoutsGroup;
